import React, { useEffect, useMemo, useState } from 'react';
import api from '../config/axios';
import moment from 'moment-timezone';

const Reports: React.FC = () => {
  const [from, setFrom] = useState<string>(moment().tz('America/Lima').startOf('month').format('YYYY-MM-DD'));
  const [to, setTo] = useState<string>(moment().tz('America/Lima').endOf('month').format('YYYY-MM-DD'));
  const [teamId, setTeamId] = useState<string>('');
  const [teams, setTeams] = useState<any[]>([]);
  const [sellers, setSellers] = useState<any[]>([]);
  const [sellerEmail, setSellerEmail] = useState<string>('');
  const [segment, setSegment] = useState<'B2B'|'B2C'|''>('');
  const [rows, setRows] = useState<any[]>([]);
  const [period, setPeriod] = useState<'SEMANAL'|'MENSUAL'>('MENSUAL');
  const [dateForTargets, setDateForTargets] = useState<string>(moment().tz('America/Lima').format('YYYY-MM-DD'));
  const [targets, setTargets] = useState<any[]>([]);

  useEffect(() => {
    api.get('/teams').then(r=> setTeams(r.data||[])).catch(()=>{});
    api.get('/users', { params: { role: 'vendedor' } }).then(r=> setSellers(r.data||[])).catch(()=>{});
  }, []);
  useEffect(() => { (async()=>{ const { data } = await api.get('/reports/summary',{ params:{ from, to, teamId: teamId||undefined, sellerEmail: sellerEmail||undefined, segment: segment||undefined }}); setRows(data||[]); })(); }, [from,to,teamId,sellerEmail,segment]);
  useEffect(() => { (async()=>{ const { data } = await api.get('/reports/targets',{ params:{ period, date: dateForTargets, teamId: teamId||undefined }}); setTargets(data||[]); })(); }, [period,dateForTargets,teamId]);

  const totals = rows.reduce((a,r)=>({ units: a.units+Number(r.units||0), amount: a.amount+Number(r.amount||0) }), { units:0, amount:0 });

  const targetsByTeam = useMemo(()=>{
    const map: Record<string, any> = {};
    targets.forEach((t:any)=>{ map[t.team_id] = t; });
    return map;
  },[targets]);

  const teamTotals = useMemo(()=>{
    const agg: Record<string, { units:number; amount:number; team_name:string }>= {};
    rows.forEach((r:any)=>{
      const key = r.team_id || 'no_team';
      if (!agg[key]) agg[key] = { units:0, amount:0, team_name: r.team_name||'-' };
      agg[key].units += Number(r.units||0);
      agg[key].amount += Number(r.amount||0);
    });
    return agg;
  },[rows]);

  const maxUnits = useMemo(()=>{
    return Object.values(teamTotals).reduce((m:any, t:any)=> Math.max(m, t.units), 0) || 1;
  }, [teamTotals]);

  return (
    <div className="container">
      <h2 className="mb-3">Reportes - General</h2>
      <div className="card mb-3"><div className="card-body">
        <div className="row g-2">
          <div className="col-6 col-md-3"><label className="form-label">Desde</label><input className="form-control" type="date" value={from} onChange={(e)=>setFrom(e.target.value)} /></div>
          <div className="col-6 col-md-3"><label className="form-label">Hasta</label><input className="form-control" type="date" value={to} onChange={(e)=>setTo(e.target.value)} /></div>
          <div className="col-12 col-md-3"><label className="form-label">Equipo</label><select className="form-select" value={teamId} onChange={(e)=>setTeamId(e.target.value)}><option value="">Todos</option>{teams.map(t=><option key={t.id} value={t.id}>{t.name}</option>)}</select></div>
          <div className="col-12 col-md-3"><label className="form-label">Vendedor</label><select className="form-select" value={sellerEmail} onChange={(e)=>setSellerEmail(e.target.value)}><option value="">Todos</option>{sellers.map((s:any)=><option key={s.email} value={s.email}>{s.name} ({s.email})</option>)}</select></div>
          <div className="col-6 col-md-2"><label className="form-label">Segmento</label><select className="form-select" value={segment} onChange={(e)=>setSegment(e.target.value as any)}><option value="">Todos</option><option value="B2B">B2B</option><option value="B2C">B2C</option></select></div>
        </div>
        <div className="mt-2"><strong>Ventas:</strong> {totals.units} | <strong>Monto:</strong> {totals.amount.toFixed(2)}</div>
      </div></div>

      <div className="card mb-3"><div className="card-body">
        <div className="row g-2 align-items-end">
          <div className="col-6 col-md-3">
            <label className="form-label">Periodo</label>
            <select className="form-select" value={period} onChange={(e)=>setPeriod(e.target.value as any)}>
              <option value="SEMANAL">Semanal</option>
              <option value="MENSUAL">Mensual</option>
            </select>
          </div>
          <div className="col-6 col-md-3">
            <label className="form-label">Fecha de referencia</label>
            <input className="form-control" type="date" value={dateForTargets} onChange={(e)=>setDateForTargets(e.target.value)} />
          </div>
        </div>

        <div className="row g-3 mt-1">
          {Object.entries(teamTotals).map(([teamKey, agg])=>{
            const t = targetsByTeam[teamKey];
            const targetUnits = Number(t?.target_units||0);
            const progress = targetUnits>0 ? Math.round((agg.units/targetUnits)*100) : 0;
            const badgeClass = progress>=110 ? 'bg-success' : progress>=100 ? 'bg-primary' : progress>=90 ? 'bg-warning text-dark' : 'bg-secondary';
            return (
              <div className="col-12 col-md-4" key={teamKey}>
                <div className="card h-100">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <div className="fw-bold">{agg.team_name}</div>
                        <div className="text-muted" style={{fontSize:'0.9rem'}}>
                          Objetivo: {targetUnits} | Logrado: {agg.units}
                        </div>
                      </div>
                      <span className={`badge ${badgeClass}`} style={{fontSize:'1rem'}}>{progress}%</span>
                    </div>
                    {t && (
                      <div className="mt-2 text-muted" style={{fontSize:'0.85rem'}}>
                        {t.period_type} del {t.period_start} al {t.period_end}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div></div>
      <div className="card"><div className="card-body">
        <div className="table-responsive">
          <table className="table table-sm">
            <thead><tr><th>Equipo</th><th>Vendedor</th><th>Ventas</th><th>Monto</th></tr></thead>
            <tbody>
              {rows.map((r,i)=>(<tr key={i}><td>{r.team_name||'-'}</td><td>{r.seller_email}</td><td>{r.units}</td><td>{Number(r.amount).toFixed(2)}</td></tr>))}
            </tbody>
          </table>
        </div>
      </div></div>

      <div className="card mt-3"><div className="card-body">
        <h5 className="card-title">Barras por equipo (ventas)</h5>
        <div className="row g-2">
          {Object.entries(teamTotals).map(([teamKey, agg])=>{
            const pct = Math.max(2, Math.round((agg.units / maxUnits) * 100));
            return (
              <div className="col-12" key={teamKey}>
                <div className="d-flex justify-content-between" style={{fontSize:'0.9rem'}}>
                  <div className="fw-bold">{agg.team_name}</div>
                  <div>{agg.units}</div>
                </div>
                <div className="progress" style={{height: 12}}>
                  <div className="progress-bar" role="progressbar" style={{ width: pct + '%'}} aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}></div>
                </div>
              </div>
            );
          })}
        </div>
      </div></div>
    </div>
  );
};

export default Reports;
